import React, { useEffect } from "react";
import "../../modal.css";

export default function ServiceCsatDone({ CloseChat, restartChat ,askForRating}) {
  // useEffect(() => {
  //   setTimeout(() => {
  //     CloseChat()
  //   }, 3000)
  // })
  const [closeCsatDone, setCloseCsatDone] = React.useState(false);
  return (
    <>
      {!closeCsatDone ?
        <div id="popup1" class="overlay open">
          <div class="chatpopup">

            <div className="closeIconCsatDone" onClick={() => setCloseCsatDone(true)}>&#x2715;</div>

            <div class="feedbackdone">

              <div class="sm-submit-text">
                <div className="thmb-icon"> </div>
                <div className="infoheader">
                  {!askForRating ?
                    'Thank you! If you have any more questions, feel free to reach out. Have a great day!'
                    : 'Thank you for submitting the feedback.'
                  }

                </div>
              </div>
              {/* <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div> */}

            </div>
          </div>
        </div>
        : null}</>
  );
}
